export const SEARCH_SHOULD_SEARCH = 'search/SEARCH_SHOULD_SEARCH';
export const SEARCH_SET_LATEST_QUERY = 'search/SEARCH_SET_LATEST_QUERY';
